import axios from "axios";
import { config } from "../../Utils/helpers";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const GetProjectReportList = (listData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "PROJECT_REPORT_LIST_REQUEST" });
      const { data } = await axios.post(`${BASE_URL}/project-report/list`, listData, config);
      if (data.statusCode === 200) {
        dispatch({ type: "PROJECT_REPORT_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "PROJECT_REPORT_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "PROJECT_REPORT_LIST_FAIL", payload: error?.response });
    }
  };
};

export const AddProjectReport = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "PROJECT_REPORT_ADD_REQUEST" });
      const { data } = await axios.post(`${BASE_URL}/project-report/add`, payload, config);
      if (data.statusCode === 200) {
        dispatch({ type: "PROJECT_REPORT_ADD_SUCCESS", payload: data });
        return Promise.resolve(data);
      } else {
        dispatch({ type: "PROJECT_REPORT_ADD_FAIL", payload: data.message || "Add failed" });
        return Promise.reject(new Error(data.message));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Network error";
      dispatch({ type: "PROJECT_REPORT_ADD_FAIL", payload: errorMessage });
      return Promise.reject(new Error(errorMessage));
    }
  };
};

export const UpdateProjectReport = (id, payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "PROJECT_REPORT_UPDATE_REQUEST" });
      const { data } = await axios.put(`${BASE_URL}/project-report/update/${id}`, payload, config);
      if (data.statusCode === 200) {
        dispatch({ type: "PROJECT_REPORT_UPDATE_SUCCESS", payload: data });
        return Promise.resolve(data);
      } else {
        dispatch({ type: "PROJECT_REPORT_UPDATE_FAIL", payload: data.message || "Update failed" });
        return Promise.reject(new Error(data.message));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Network error";
      dispatch({ type: "PROJECT_REPORT_UPDATE_FAIL", payload: errorMessage });
      return Promise.reject(new Error(errorMessage));
    }
  };
};

export const UpdateProjectReportStatus = (id, status) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "PROJECT_REPORT_STATUS_REQUEST" });
      const { data } = await axios.put(`${BASE_URL}/project-report/status/${id}`, { status }, config);
      if (data.statusCode === 200) {
        dispatch({ type: "PROJECT_REPORT_STATUS_SUCCESS", payload: data });
        return Promise.resolve(data);
      } else {
        dispatch({ type: "PROJECT_REPORT_STATUS_FAIL", payload: data.message || "Status update failed" });
        return Promise.reject(new Error(data.message));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Network error";
      dispatch({ type: "PROJECT_REPORT_STATUS_FAIL", payload: errorMessage });
      return Promise.reject(new Error(errorMessage));
    }
  };
};

export const ViewProjectReport = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "PROJECT_REPORT_VIEW_REQUEST" });
      const { data } = await axios.get(`${BASE_URL}/project-report/view/${id}`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "PROJECT_REPORT_VIEW_SUCCESS", payload: data });
        return Promise.resolve(data);
      } else {
        dispatch({ type: "PROJECT_REPORT_VIEW_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "PROJECT_REPORT_VIEW_FAIL", payload: error?.response?.data?.message });
    }
  };
};